import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { AddSeriesBtn, ClearCompareBtn, ComparisonGraphic, StartComparisonBtn } from 'components/lib/buttons/IconButtons';
import { PrimaryButton } from 'components/lib/buttons/Button';
import SeriesComparisonControlledSelect from 'components/lib/formElements/SeriesComparisonControlledSelect';
import CallOut from 'components/lib/containers/CallOut';
import ComparedSeries from 'components/lib/cards/ComparedSeries';
import ZoomedChart from 'components/series/seriesComparison/ZoomedChart';
import BrushChart from 'components/series/seriesComparison/BrushChart';
import LegendSection from 'components/series/seriesComparison/LegendSection';
import SeriesComparisonLanding from 'components/series/seriesComparison/SeriesComparisonLanding';
import { VictoryChart, VictoryLine, VictoryScatter, VictoryAxis, VictoryTooltip, VictoryZoomContainer, VictoryBrushContainer, VictoryLabel } from 'victory';
import theme from 'themes/victoryChartTheme';
import styles from 'styles/components/series/SeriesComparisonChart.css';

export default class SeriesComparisonChart extends Component {

  constructor(props) {
    super();
    this.state = {
      displaySeries2: (props.selectedSeries2) ? true : false,
      displaySeries3: (props.selectedSeries3) ? true : false,
      selectedDomain: {x:[1,10]},
      zoomDomain: {x:[0.95,10]},
      openMenu: false
    };
    this.getProductionNames = this.getProductionNames.bind(this);
    this.handleBrush = this.handleBrush.bind(this);
    this.handleZoom = this.handleZoom.bind(this);
    this.getAverageTicketPrice = this.getAverageTicketPrice.bind(this);
    this.onClear = this.onClear.bind(this);
    this.toggleAdditionalSeries = this.toggleAdditionalSeries.bind(this);
    this.getHighestValueForComparison = this.getHighestValueForComparison.bind(this);
  }

  componentWillReceiveProps(nProps){
    this.setState({
      selectedDomain: {x:[1,10]},
      zoomDomain: {x:[0.95,10]}
    })
  }

  handleZoom(domain) {
    this.setState({selectedDomain: domain});
  }

  handleBrush(domain) {
    if(domain.x[1] - domain.x[0] > 1){
      this.setState({zoomDomain: domain})
    }
    // if(domain.x[1] - domain.x[0] < 1 || domain.x[0] > 1) {
    //   let adjustedDomain = {x:[domain.x[0]-0.5, domain.x[1]+0.5]}
    //
    //   if(domain.x[0] > 1 && domain.x[1] > domain.x[0]) {
    //     this.setState({zoomDomain: adjustedDomain})
    //   }
    // }
  }

  toggleAdditionalSeries() {
    if(this.state.displaySeries2) {
      this.setState({
        displaySeries3: true
      })
    } else {
      this.setState({
        displaySeries2: true
      })
    }
  }

  onClear(series) {
    if(series === 'SERIES2') {
      this.setState({
        displaySeries2: false
      }, () => {
        this.props.resetField(series)
      })
    } else if (series === 'SERIES3') {
      this.setState({
        displaySeries3: false
      }, () => {
        this.props.resetField(series)
      })
    }
  }

  getAverageTicketPrice(index){
    let { data } = this.props;
    let value = data[index].totalTicketRevenueSansPackages / data[index].totalTicketsSoldSansPackages;
    return numeral(value).format('$0,0.00')
  }

  getProductionNames(){
    let { productions } = this.props;
    let nameIds = {};
    if(productions) {
      productions.forEach((elem) => {
        nameIds[elem.productionId] = elem.productionName;
      })
      return nameIds;
    }
  }

  getHighestValueForComparison = (dataObj) => {
    let highest = 0;
    for(let key in dataObj){
      dataObj[key].data.forEach((elem) => {
        if(elem.value > highest){
          highest = elem.value;
        }
      })
    }
    return highest;
  }

  render() {
    let { productionName, data, productionId, selectedSeries2, selectedSeries3, productions, showComparisonChart, chartSize, series1SalesRevenue } = this.props;
    let { error, series1Label, displaySeries2Label } = this.props.labels;
    let displayAddSeries = true;
    let productionNamesObj = this.getProductionNames();
    let labelUnit = '';
    let unit = ''
    let { width, height } = chartSize;
    let colors = {
      series1: "#3395FF",
      series2: "#27CC6A",
      series3: "#FEBA2C"
    };
    if (data) {
      unit = (data[productionId]) ? data[productionId].unit : 'Loading...';
      if(data[productionId] && data[productionId].unit === 'DAYS') {
        labelUnit = 'Day';
      } else if(data[productionId] && data[productionId].unit === 'WEEKS') {
        labelUnit = 'Week';
      } else if(data[productionId] && data[productionId].unit === 'MONTHS') {
        labelUnit = 'Month';
      }
    }
    if(this.state.displaySeries2 && this.state.displaySeries3) {
      displayAddSeries = false
    }
    (data && data[productionId])
    if(!showComparisonChart) {
      return (
        <SeriesComparisonLanding
          hasData={(series1SalesRevenue) ? true : false}
          toggleSeriesComparisonChart={this.props.toggleSeriesComparisonChart} />
      )
    } else {
      return (
        <div style={{ height: '100%' }} className={styles.seriesComparisonChart}>
          { (data && data[productionId]) &&
          <div className={styles.content}>
            {/* LEGEND ON THE LEFT SIDE */}
            <div className={styles.listSection}>
              <LegendSection
                changeSeries2={this.props.changeSeries2}
                changeSeries3={this.props.changeSeries3}
                colors={colors}
                series1LegendData={data && data[productionId]}
                series2LegendData={(data[selectedSeries2]) && data[selectedSeries2]}
                series3LegendData={(data[selectedSeries3]) && data[selectedSeries3]}
                getAverageTicketPrice={this.getAverageTicketPrice}
                displaySeries2={this.state.displaySeries2}
                displaySeries3={this.state.displaySeries3}
                selectedSeries2={this.props.selectedSeries2}
                selectedSeries3={this.props.selectedSeries3}
                onClear={this.onClear}
                clientId={this.props.clientId}
                error={error}
                productions={productions}
                onChange={this.props.changeSeries2}
                openMenu={this.state.openMenu}
                handleMenu={(v) => { this.setState({openMenu: v});}}
                toggleAdditionalSeries={this.toggleAdditionalSeries}
                // handleSeriesCompare={this.props.handleSeriesCompare}
                productionNamesObj={productionNamesObj}
                displayAddSeries={displayAddSeries} />
            </div>
            {/* BRUSH AND ZOOM CHART */}
            <div className={styles.chartSection}>
              {/* Chart and Zoom Chart Containers */}
              <ZoomedChart
                chartSize={chartSize}
                zoomDomain={this.state.zoomDomain}
                handleZoom={this.handleZoom}
                unit={unit}
                colors={colors}
                series1Data={(data[productionId]) && data[productionId].data}
                series2Data={(data[selectedSeries2]) && data[selectedSeries2].data}
                series3Data={(data[selectedSeries3]) && data[selectedSeries3].data}
                labelUnit={labelUnit}
                selectedSeries2={this.props.selectedSeries2}
                selectedSeries3={this.props.selectedSeries3}
              />
              {/* Chart and Brush Chart Containers */}
              <BrushChart
                chartSize={chartSize}
                ref="brushChart"
                selectedDomain={this.state.selectedDomain}
                handleBrush={this.handleBrush}
                colors={colors}
                data={data && data}
                getHighestValueForComparison={this.getHighestValueForComparison}
                series1Data={(data[productionId]) && data[productionId].data}
                series2Data={(data[selectedSeries2]) && data[selectedSeries2].data}
                series3Data={(data[selectedSeries3]) && data[selectedSeries3].data}
                selectedSeries2={this.props.selectedSeries2}
                selectedSeries3={this.props.selectedSeries3} />
            </div>
          </div>
        }
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/series/seriesComparison/SeriesComparisonChart.js